var _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _g4, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCentreHeroRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 178,
    viewBox: "0 0 161 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_184_805)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 22,
    width: 80.3012,
    height: 95.2727,
    rx: 3.04,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 22.5,
    width: 79.3012,
    height: 94.2727,
    rx: 2.54,
    stroke: "#222831"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2364 71.5065L54.238 71.5041C56.0405 68.8003 57.0875 65.5604 57.0875 62.032C57.0875 52.6085 49.4653 44.9863 40.0418 44.9863C30.6182 44.9863 22.9961 52.6085 22.9961 62.032C22.9961 65.5604 24.043 68.8003 25.8456 71.5041L25.8472 71.5065C28.474 75.3981 32.6348 78.1503 37.4804 78.8587C38.3116 79.0049 39.1656 79.0777 40.0418 79.0777C40.918 79.0777 41.772 79.0049 42.6032 78.8587C47.4487 78.1503 51.6095 75.3981 54.2364 71.5065Z",
    fill: "#52BAE2",
    fillOpacity: 0.4,
    stroke: "#222831"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9915 91.498L41.4252 79.3589C41.9248 79.3234 42.4168 79.2631 42.901 79.1779C47.5385 78.5 51.5488 75.9499 54.1874 72.3206L62.9846 81.1178L62.9879 81.121C64.0002 82.1149 63.5113 83.8878 62.0886 84.225C62.0885 84.225 62.0884 84.225 62.0884 84.225L58.1885 85.1467L58.1854 85.1475C57.1401 85.4018 56.301 86.199 56.0669 87.2715L55.2407 90.7413L55.2407 90.7416C54.8871 92.2302 52.987 92.6812 51.997 91.5043L51.997 91.5043L51.9915 91.498ZM37.7783 79.1779C38.2629 79.2632 38.7553 79.3235 39.2553 79.3589L28.6875 91.5219L28.6875 91.5218L28.6823 91.5279C27.6923 92.7047 25.7922 92.2538 25.4386 90.7652L25.4386 90.7649L24.6113 87.2903L24.6107 87.2879C24.3551 86.2371 23.5305 85.4029 22.4877 85.1697L18.5909 84.2487C18.5909 84.2487 18.5908 84.2486 18.5907 84.2486C17.1736 83.9128 16.6728 82.1396 17.6947 81.1178L26.4919 72.3206C29.1305 75.9499 33.1408 78.5 37.7783 79.1779Z",
    fill: "#52BAE2",
    stroke: "#222831"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3211 58.3126L44.3211 58.3126L46.8471 58.7375C46.8477 58.7376 46.8482 58.7377 46.8488 58.7378C47.7414 58.8826 48.462 59.3136 48.6944 60.0425C48.9264 60.7704 48.5905 61.5424 47.9481 62.1847L47.5946 61.8312L47.9481 62.1847L45.9863 64.1465C45.8945 64.2383 45.8008 64.3989 45.7444 64.5974C45.6881 64.7956 45.6831 64.9821 45.716 65.1136L45.7179 65.1214L45.7179 65.1214L46.285 67.5552L44.3211 58.3126ZM44.3211 58.3126L44.3161 58.3118C44.1907 58.292 44.0281 58.2215 43.8706 58.1052C43.7125 57.9883 43.6015 57.8561 43.5508 57.7548L42.1563 54.9656C41.7434 54.14 41.1145 53.5547 40.347 53.5547C39.5737 53.5547 38.9642 54.1463 38.5868 54.9739L37.1963 57.7548C37.1454 57.8566 37.0337 57.9895 36.8767 58.1072C36.7195 58.2252 36.5623 58.2938 36.4504 58.3125L36.4497 58.3126L33.9205 58.738L33.9205 58.738L33.9166 58.7387C33.0288 58.8954 32.3092 59.3256 32.0767 60.0505C31.8435 60.7775 32.1821 61.5442 32.8226 62.1847L33.1762 61.8312M44.3211 58.3126L36.5326 58.8057L34.0035 59.2311C32.3962 59.5147 32.018 60.673 33.1762 61.8312M33.1762 61.8312L32.8226 62.1847L34.7845 64.1465C34.8693 64.2313 34.9595 64.3913 35.0157 64.5998C35.0709 64.8043 35.0777 64.9981 35.0515 65.1274M33.1762 61.8312L35.0515 65.1274M35.0515 65.1274L34.4858 67.5552C34.4858 67.5554 34.4857 67.5556 34.4857 67.5557C34.2515 68.5544 34.335 69.5034 35.0066 69.9914C35.6746 70.4768 36.6069 70.2731 37.4936 69.7558L37.4958 69.7546L39.8594 68.36L39.8595 68.3601L39.8661 68.356C39.9812 68.2857 40.1684 68.2344 40.3854 68.2344C40.6024 68.2344 40.7896 68.2857 40.9047 68.356L40.9046 68.3561L40.9113 68.36L43.2727 69.7532C43.2731 69.7535 43.2735 69.7537 43.2739 69.7539C44.1615 70.2837 45.096 70.4905 45.766 69.9989C46.4352 69.5079 46.5194 68.5551 46.2851 67.556L35.0515 65.1274Z",
    fill: "#52BAE2",
    stroke: "#222831"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_184_805)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.5137,
    y: 52.917,
    width: 80.3012,
    height: 95.2727,
    rx: 3.04,
    transform: "rotate(30 90.5137 52.917)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.6967,
    y: 53.6,
    width: 79.3012,
    height: 94.2727,
    rx: 2.54,
    transform: "rotate(30 90.6967 53.6)",
    stroke: "#222831"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.729 122.908L112.732 122.907C115.645 121.467 118.171 119.184 119.935 116.129C124.647 107.968 121.857 97.5555 113.696 92.8437C105.535 88.132 95.1231 90.9219 90.4113 99.0829C88.6471 102.139 87.9339 105.468 88.143 108.711L88.1432 108.714C88.4723 113.397 90.6996 117.861 94.5418 120.897C95.1885 121.44 95.8916 121.93 96.6505 122.368C97.4093 122.806 98.1853 123.17 98.9782 123.459C103.529 125.268 108.508 124.965 112.729 122.908Z",
    fill: "#F0D04E",
    fillOpacity: 0.4,
    stroke: "#222831"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.789 139.099L97.7079 123.303C98.1583 123.522 98.6144 123.716 99.0764 123.884C103.432 125.616 108.18 125.413 112.279 123.589L115.499 135.606L115.501 135.61C115.88 136.977 114.57 138.268 113.17 137.849C113.17 137.849 113.17 137.849 113.17 137.849L109.331 136.697L109.328 136.696C108.296 136.394 107.171 136.665 106.432 137.476L103.981 140.068L103.981 140.069C102.931 141.181 101.06 140.621 100.791 139.107L100.791 139.107L100.789 139.099ZM94.64 121.323C95.0171 121.639 95.4134 121.937 95.8287 122.218L80.5952 127.468L80.5952 127.468L80.5877 127.47C79.1419 127.994 77.7218 126.654 78.1599 125.188L78.16 125.188L79.1809 121.765L79.1816 121.763C79.4856 120.725 79.1886 119.59 78.4021 118.867L75.4879 116.121C75.4878 116.121 75.4878 116.121 75.4877 116.12C74.4284 115.121 74.8813 113.335 76.2772 112.961L88.2943 109.741C88.7648 114.203 90.9628 118.417 94.64 121.323Z",
    fill: "#F0D04E",
    stroke: "#222831"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.738 106.524L110.738 106.524L112.713 108.155C112.713 108.155 112.714 108.155 112.714 108.156C113.415 108.728 113.824 109.461 113.66 110.209C113.497 110.955 112.82 111.456 111.943 111.691L111.813 111.208L111.943 111.691L109.263 112.409C109.138 112.442 108.976 112.534 108.828 112.678C108.68 112.822 108.583 112.981 108.545 113.111L108.543 113.119L108.543 113.119L107.817 115.51L110.738 106.524ZM110.738 106.524L110.734 106.521C110.635 106.441 110.53 106.298 110.451 106.119C110.373 105.939 110.343 105.769 110.35 105.656L110.537 102.543C110.592 101.621 110.34 100.8 109.675 100.416C109.005 100.03 108.182 100.237 107.441 100.765L104.847 102.478C104.752 102.541 104.588 102.6 104.393 102.624C104.198 102.647 104.028 102.628 103.922 102.588L103.921 102.588L101.518 101.692L101.518 101.692L101.514 101.691C100.667 101.382 99.8287 101.395 99.2649 101.907C98.6995 102.42 98.6094 103.253 98.8438 104.128L99.3268 103.998M110.738 106.524L103.746 103.057L101.343 102.16C99.8095 101.602 98.9029 102.416 99.3268 103.998M99.3268 103.998L98.8438 104.128L99.5619 106.808C99.593 106.924 99.5911 107.107 99.5356 107.316C99.4811 107.521 99.3901 107.692 99.3027 107.791M99.3268 103.998L99.3027 107.791M99.3027 107.791L97.5989 109.61C97.5988 109.611 97.5987 109.611 97.5986 109.611C96.8965 110.359 96.4942 111.222 96.8319 111.981C97.1677 112.735 98.077 113.025 99.1035 113.02L99.106 113.02L101.85 112.994L101.85 112.994L101.858 112.994C101.993 112.991 102.181 113.04 102.369 113.148C102.556 113.257 102.693 113.395 102.757 113.513L102.757 113.513L102.761 113.52L104.11 115.907C104.11 115.908 104.11 115.908 104.11 115.909C104.614 116.811 105.32 117.458 106.146 117.367C106.971 117.276 107.52 116.493 107.817 115.511L99.3027 107.791Z",
    fill: "#F0D04E",
    stroke: "#222831"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_184_805)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.3555,
    y: 35.5371,
    width: 80.3012,
    height: 95.2727,
    rx: 3.04,
    transform: "rotate(15 44.3555 35.5371)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.709,
    y: 36.1495,
    width: 79.3012,
    height: 94.2727,
    rx: 2.54,
    transform: "rotate(15 44.709 36.1495)",
    stroke: "#222831"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.931 97.3944L83.9332 97.3925C86.3741 95.2473 88.2239 92.3889 89.1371 88.9807C91.5761 79.8782 86.1864 70.5431 77.084 68.1041C67.9815 65.6651 58.6463 71.0547 56.2074 80.1572C55.2941 83.5654 55.4669 86.9658 56.5082 90.044L56.5091 90.0467C58.0392 94.4856 61.3459 98.221 65.843 100.159C66.6081 100.516 67.4141 100.807 68.2605 101.034C69.1069 101.261 69.9506 101.411 70.7913 101.485C75.6551 102.055 80.3864 100.474 83.931 97.3944Z",
    fill: "#FF7F4C",
    fillOpacity: 0.4,
    stroke: "#222831"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5863 116.123L69.5219 101.663C70.0136 101.758 70.5044 101.827 70.9942 101.87C75.6492 102.416 80.1828 100.99 83.6709 98.1677L89.8914 108.942L89.8938 108.946C90.6144 110.168 89.6832 111.754 88.2218 111.711C88.2217 111.711 88.2216 111.711 88.2215 111.711L84.216 111.592L84.2128 111.592C83.1373 111.567 82.1204 112.12 81.6167 113.096L79.9207 116.233L79.9206 116.234C79.1938 117.58 77.2417 117.524 76.59 116.131L76.59 116.131L76.5863 116.123ZM66.0461 100.544C66.4922 100.752 66.9522 100.938 67.4259 101.101L54.0702 110.115L54.0702 110.115L54.0636 110.119C52.8028 111 51.0841 110.072 51.1279 108.543L51.1279 108.543L51.2281 104.972L51.2282 104.97C51.2532 103.889 50.6727 102.87 49.7257 102.374L46.2001 100.476C46.2001 100.476 46.2 100.476 46.1999 100.476C44.918 99.785 44.8932 97.9426 46.1448 97.2201L56.919 90.9995C58.5284 95.1881 61.7421 98.6893 66.0461 100.544Z",
    fill: "#FF7F4C",
    stroke: "#222831"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7676 82.0834L77.7676 82.0834L80.0976 83.1477C80.0981 83.1479 80.0986 83.1481 80.0991 83.1483C80.9238 83.5192 81.5084 84.1221 81.5441 84.8863C81.5798 85.6494 81.0555 86.3082 80.2689 86.7624L80.0188 86.3294L80.2688 86.7624L77.8661 88.1496C77.7537 88.2144 77.6216 88.3453 77.5157 88.5224C77.41 88.6994 77.357 88.8782 77.3547 89.0137L77.3546 89.0217L77.3545 89.0217L77.2724 91.5194L77.7676 82.0834ZM77.7676 82.0834L77.763 82.0814C77.647 82.0298 77.5081 81.9197 77.3861 81.7665C77.2637 81.6127 77.1907 81.4563 77.1679 81.3453L76.5428 78.2902C76.3577 77.3859 75.9017 76.6577 75.1603 76.4591C74.4134 76.259 73.6716 76.6726 73.0927 77.3744L71.03 79.7006C70.9544 79.7858 70.8121 79.8852 70.63 79.9583C70.4476 80.0316 70.278 80.0572 70.1651 80.0462L70.1644 80.0462L67.6113 79.8025L67.6113 79.8025L67.6073 79.8022C66.7092 79.7237 65.9027 79.953 65.4906 80.593C65.0772 81.2349 65.2058 82.0631 65.6587 82.8476L66.0918 82.5976M77.7676 82.0834L70.1169 80.5439L67.5638 80.3003C65.9379 80.1582 65.2728 81.1791 66.0918 82.5976M66.0918 82.5976L65.6588 82.8476L67.046 85.2503C67.106 85.3542 67.1517 85.532 67.1521 85.748C67.1524 85.9599 67.1088 86.1487 67.05 86.2669M66.0918 82.5976L67.05 86.2669M67.05 86.2669L65.8752 88.4656C65.8752 88.4657 65.8751 88.4659 65.875 88.466C65.3904 89.37 65.2253 90.3083 65.7478 90.9536C66.2674 91.5953 67.2207 91.6398 68.211 91.3697L68.2134 91.369L70.8575 90.6338L70.8575 90.6338L70.865 90.6316C70.9943 90.5935 71.1884 90.5924 71.398 90.6485C71.6076 90.7047 71.7752 90.8027 71.8681 90.9004L71.8681 90.9005L71.8735 90.906L73.7939 92.8629C73.7942 92.8632 73.7945 92.8635 73.7948 92.8639C74.5151 93.6053 75.3642 94.047 76.1386 93.7455C76.9121 93.4444 77.24 92.5459 77.2723 91.5202L67.05 86.2669Z",
    fill: "#FF7F4C",
    stroke: "#222831"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_184_805)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.001,
    cy: 23.9996,
    r: 23,
    transform: "rotate(30 116.001 23.9996)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.001,
    cy: 23.9996,
    r: 22.5,
    transform: "rotate(30 116.001 23.9996)",
    stroke: "#222831"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M111.012 32.558L109.4 23.0629L110.079 21.2147L111.578 21.7655C112.177 21.9858 112.732 22.0953 113.243 22.094C113.776 22.0822 114.254 21.9649 114.676 21.742C115.115 21.5253 115.478 21.2052 115.766 20.7818L110.896 18.9917L111.576 17.1435L116.421 18.9244C116.48 18.4547 116.446 18.0075 116.319 17.5827C116.208 17.164 115.986 16.7896 115.654 16.4596C115.345 16.119 114.915 15.8477 114.366 15.6458L112.393 14.9205L113.072 13.0723L124.335 17.2124L123.656 19.0607L119.735 17.6195C119.902 18.0399 120.01 18.4669 120.058 18.9005C120.123 19.3403 120.109 19.7889 120.017 20.2463L122.839 21.2836L122.16 23.1319L119.387 22.1129C118.768 23.2839 117.939 24.0753 116.899 24.487C115.865 24.882 114.687 24.978 113.363 24.7749L115.458 34.192L111.012 32.558Z",
    fill: "#FF4A01"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_184_805",
    x: 0,
    y: 22,
    width: 82.3008,
    height: 98.2725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.156863 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_184_805"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_184_805",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_184_805",
    x: 43.9902,
    y: 54.0293,
    width: 116.955,
    height: 123.435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.156863 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_184_805"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_184_805",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_184_805",
    x: 20.3789,
    y: 36.2197,
    width: 102.859,
    height: 114.444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.156863 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_184_805"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_184_805",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_184_805",
    x: 92.9961,
    y: 0.996094,
    width: 48.0078,
    height: 49.0078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.156863 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_184_805"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_184_805",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentreHeroRight);
export default __webpack_public_path__ + "static/media/centre-hero-right.7e17ab70c435425ae941401575ff9cca.svg";
export { ForwardRef as ReactComponent };